import exportPDFModel from 'models/export-pdf-model';
import siteModel from 'models/site-model';

const ExportPromptContentCard = {

    // Restores the delayed re-layout the old orientation-swap call was also
    // relying on (removing it broke export sending) without touching
    // orientation, which is already correct without any swap.
    oncreate: () => {
        setTimeout(() => {
            exportPDFModel.formatToScreen();
            exportPDFModel.forcePostRender();
        }, 100);
    },

    onremove: () => {
        siteModel.view = null;
    },

    view: () => {
        return <div>
            <div class="tool-launcher export-prompt">
                <div class="asset-title-wrap">
                    <i class="icon-download icon asset-icon" />
                    <div class="asset-title">PDF Export</div>
                    {exportPDFModel.isLoading || exportPDFModel.isWaiting ? <i className="loader-v2"/> : null}
                    <div class="btn btn-smallest btn-secondary btn-pill asset-cancel" onclick={() => exportPDFModel.close()}>{exportPDFModel.isWaiting ? 'Close' : 'Cancel'}</div>
                </div>
                <div class="tool-launcher-prompt">
                    Position the map within the viewer and tap "Export" when ready to export your PDF.
                </div>
                <div>
                    <div class="prompt-container clear">
                        {exportPDFModel.needsRecipientEmail() &&
                            <div className={`export-email ${exportPDFModel.recipientEmailError ? 'error' : ''}`}>
                                <label for="content-card-export-email">Email Address</label>
                                <input id="content-card-export-email"
                                    type="email"
                                    value={exportPDFModel.recipientEmail}
                                    oninput={(e) => exportPDFModel.setRecipientEmail(e.target.value)}
                                    aria-invalid={exportPDFModel.recipientEmailError ? 'true' : 'false'}
                                    aria-describedby="content-card-export-email-error"/>
                                {exportPDFModel.recipientEmailError &&
                                    <div id="content-card-export-email-error" className="error-msg">{exportPDFModel.recipientEmailError}</div>}
                            </div>}
                        <div className={`btn btn-primary btn-pill btn-small right ${exportPDFModel.isLoading || exportPDFModel.isWaiting ? 'disabled' : ''}`}
                            onclick={() => exportPDFModel.send()}>
                            <span className="btn-label">Export</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>;
    }
};

export default ExportPromptContentCard;
